<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class="d-flex flex-row justify-content-between pb-4">
        <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{'LOGIN.COMPANY_NAME' | translate}} *
                <span *ngIf="companyName.invalid && (companyName.dirty || companyName.touched)" class="alert">
                    <span *ngIf="companyName.errors?.['required']">
                        <i class="pi pi-info-circle float-end me-1"
                            pTooltip="{{ 'INFO.COMPANY_REQUIRED' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                    <span *ngIf="companyName.errors?.['maxlength']">
                        <i class="pi pi-info-circle float-end me-1 "
                            pTooltip="{{ 'INFO.MAX_255_CHARS' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                </span>
            </label>
            <input type="text" class="input_text_field" required maxlength="255"
                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" [(ngModel)]="companyUpdateInfo.companyName"
                #companyName="ngModel">
        </div>
        <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{'INFO.BUSINESS_TYPE' | translate}} *
                <span *ngIf="item.invalid && (item.dirty || item.touched)" class="alert">
                    <span *ngIf="item.errors?.['required']">
                        <i class="pi pi-info-circle float-end me-1"
                            pTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}" tooltipPosition="top"></i>
                    </span>
                </span>
            </label>
            <p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..."
                [options]="list" [(ngModel)]="companyUpdateInfo.businessTypesCompanies"
                defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="name" optionValue="id" #item="ngModel"
                [required]="true" display="chip">
                <ng-template pTemplate="header">
                    <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
                </ng-template>
            </p-multiSelect>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{ 'INFO.COUNTRY' | translate}} *
                <span *ngIf="country.invalid && (country.dirty || country.touched)" class="alert">
                    <span *ngIf="country.errors?.['required']">
                        <i class="pi pi-info-circle float-end me-1" pTooltip="{{ 'INFO.REQUIRED' | translate }}"
                            tooltipStyleClass="test" tooltipPosition="top"></i>
                    </span>
                </span>
            </label>
            <p-dropdown [options]="contires" [(ngModel)]="selectedCountry" (onChange)="selectedCountryCode(selectedCountry)" optionLabel="countryName"
                placeholder="{{'BUSINESS.SELECT_COUNTRY'|translate}}" [required]="true" #country="ngModel"></p-dropdown>
        </div>
        <!-- <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{ 'LOGIN.TAX_NUMBER' | translate}} *
                <span *ngIf="companyTaxNumber.invalid && (companyTaxNumber.dirty || companyTaxNumber.touched)"
                    class="alert">
                    <span *ngIf="companyTaxNumber.errors?.['required']">
                        <i class="pi pi-info-circle float-end me-1"
                            pTooltip="{{ 'INFO.TAXN_REQUIRED' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                    <span *ngIf="companyTaxNumber.errors?.['maxlength']">
                        <i class="pi pi-info-circle float-end me-1 "
                            pTooltip="{{ 'INFO.MAX_50_CHARS' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                </span>
            </label>
            <input type="text" class="input_text_field" placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" required
                maxlength="50" [(ngModel)]="companyUpdateInfo.taxNumber" #companyTaxNumber="ngModel">
        </div> -->
        <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{ 'INFO.HQ_LOCATION' | translate}} *
                <span *ngIf="(companyAddress.dirty || companyAddress.touched)" class="alert">
                    <span *ngIf="companyAddress.errors?.['required'] || isEmptyObject(companyAdress)">
                        <i class="pi pi-info-circle float-end me-1"
                            pTooltip="{{ 'INFO.HQ_ERROR' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                    
                </span>
            </label>
            <input class="input_text_field" #search autocorrect="off" autocapitalize="off" spellcheck="off"
            (input)="changeAddress(companyUpdateInfo.address)" placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" [(ngModel)]="companyUpdateInfo.address" type="text"
                #companyAddress="ngModel" required />
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{ 'LOGIN.EMAIL' | translate }}
                <span *ngIf="companyEmail.invalid && (companyEmail.dirty || companyEmail.touched)" class="alert">
                    <span *ngIf="companyEmail.errors?.['required']">
                        <i class="pi pi-info-circle float-end me-1"
                            pTooltip="{{ 'INFO.EMAIL_REQUIRED' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                    <span *ngIf="companyEmail.errors?.['pattern']">
                        <i class="pi pi-info-circle float-end me-1 "
                            pTooltip="{{ 'INFO.INVALID_EMAIL' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                </span>
            </label>
            <input type="email" class="input_text_field" placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" #companyEmail="ngModel"
                [(ngModel)]="companyUpdateInfo.email">
        </div>
        <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{ 'LOGIN.WEB_SITE' | translate }}
                <span *ngIf="companyWebsite.invalid && (companyWebsite.dirty || companyWebsite.touched)" class="alert">
                    <span *ngIf="companyWebsite.errors?.['required']">
                        <i class="pi pi-info-circle float-end me-1" pTooltip="{{ 'INFO.WEB_REQUIRED' | translate }}"
                            tooltipStyleClass="test" tooltipPosition="top"></i>
                    </span>
                    <span *ngIf="companyWebsite.errors?.['pattern']">
                        <i class="pi pi-info-circle float-end me-1 " pTooltip="{{ 'INFO.WEB_PATTERN' | translate }}"
                            tooltipStyleClass="test" tooltipPosition="top"></i>
                    </span>
                </span>
            </label>
            <input type="text" class="input_text_field" placeholder="{{ 'INFO.PLACEHOLDER_WEBSITE' | translate }}"
                pattern="https?://.+" #companyWebsite="ngModel" [(ngModel)]="companyUpdateInfo.websiteUrl">
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div class="w-50">
            <label style="margin-top: 0px;" class="title_label">{{ 'LOGIN.PHONE' | translate}}
                <span *ngIf="companyPhone.invalid && (companyPhone.dirty || companyPhone.touched)" class="alert">
                    <span *ngIf="companyPhone.errors?.['required']">
                        <i class="pi pi-info-circle float-end me-1"
                            pTooltip="{{ 'INFO.PHONE_REQUIRED' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                    <span
                        *ngIf="companyPhone.errors?.['pattern'] || companyPhone.errors?.['minlength'] || companyPhone.errors?.['maxlength']">
                        <i class="pi pi-info-circle float-end me-1 "
                            pTooltip="{{ 'INFO.PHONE_PATTERN' | translate }}" tooltipStyleClass="test"
                            tooltipPosition="top"></i>
                    </span>
                </span>
            </label>
            <input type="text" class="input_text_field" placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
                pattern="^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$" maxlength="50" minlength="5"
                #companyPhone="ngModel" [(ngModel)]="companyUpdateInfo.phone">
        </div>
    </div>

    <div class="d-flex flex-row">
        <button class="btn_in_color" type="submit"
            [disabled]="!companyName.valid || isEmptyObject(companyAdress) || !country.valid  || !item.valid"
            (click)="save()">{{ 'ADD' | translate }}</button>
        <button class="btn_without_color" type="button" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </div>
</div>